import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import { APP_CONSTANTS } from "./constants";
import Login from "./pages/Login";
import React from "react";
import Layout from "./layout";
import { UserManagement } from "./pages/usersManagement";
import { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./store";
import { logOut } from "./store/features/authSlice";
import { SpinnerWithMessageLoader } from "./components/utils/loaders/SpinnerWithMessageLoader";
import GlobalErrorBoundary from "./ErrorBoundary";
import SharedDynamicModalWrapper from "./components/shared/model/ModalWrapper";

import { CenterManagement } from "./pages/centersManagement";


const App: React.FC = () => {
  const dispatch = useDispatch();

  const {
    user,
    currentCenter,
    accessToken: token,
    refreshToken,
  } = useSelector((state: RootState) => state.auth);
  useEffect(() => {
    if (
      (user === null || !token || !refreshToken) &&
      window.location.pathname !== "/login"
    ) {
      dispatch(logOut());
      window.location.pathname = APP_CONSTANTS.ROUTES.LOGIN;
    } else if (user && window.location.pathname === "/") {
      window.location.pathname = APP_CONSTANTS.ROUTES.USERS_MANAGEMENT;
    }
  });

  return (
    <>
      <Router>
      <GlobalErrorBoundary>
        <Routes>
          <Route path={APP_CONSTANTS.ROUTES.LOGIN} element={<Login />} />
          <Route path={APP_CONSTANTS.ROUTES.HOME} element={<Layout />}>
            <Route
              path={APP_CONSTANTS.ROUTES.USERS_MANAGEMENT}
              element={<UserManagement />}
            />
            <Route
              path={APP_CONSTANTS.ROUTES.CENTERS_MANAGEMENT}
              element={<CenterManagement />}
            />
          </Route>
        </Routes>
        <Suspense fallback={<SpinnerWithMessageLoader />}>
            <SharedDynamicModalWrapper />
          </Suspense>
          </GlobalErrorBoundary>
      </Router>
    </>
  );
};

export default App;
